import { useCompoundBody } from "@react-three/cannon";
import { useRef } from "react";
import { Group } from "three";
import { Cylinder, ObjectProps, Sphere, useDragConstraint } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useCompoundBody(() => ({
    mass: 5,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { type: 'Cylinder', position: [0, 1, 0], rotation: [0, 0, Math.PI / 2], args: [0.1, 0.1, 1.8] },
      { type: 'Sphere', position: [-1, 1, 0], args: [0.15] },
      { type: 'Cylinder', position: [-1, 0.4, 0], args: [0.1, 0.1, 1] },
      { type: 'Cylinder', position: [-1, 0, 0], rotation: [Math.PI / 2, 0, 0], args: [0.15, 0.15, 1] },
      { type: 'Cylinder', position: [-1, 0, 0.5], rotation: [Math.PI / 2, 0, 0], args: [0.2, 0.2, 0.25] },
      { type: 'Cylinder', position: [-1, 0, -0.5], rotation: [Math.PI / 2, 0, 0], args: [0.2, 0.2, 0.25] },
      { type: 'Sphere', position: [1, 1, 0], args: [0.15] },
      { type: 'Cylinder', position: [1, 0.4, 0], args: [0.1, 0.1, 1] },
      { type: 'Cylinder', position: [1, 0, 0], rotation: [Math.PI / 2, 0, 0], args: [0.15, 0.15, 1] },
      { type: 'Cylinder', position: [1, 0, 0.5], rotation: [Math.PI / 2, 0, 0], args: [0.2, 0.2, 0.25] },
      { type: 'Cylinder', position: [1, 0, -0.5], rotation: [Math.PI / 2, 0, 0], args: [0.2, 0.2, 0.25] }
    ], 
    type: 'Dynamic',
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind} >
      <Cylinder position={[0, 1, 0]} rotation={[0, 0, Math.PI / 2]} args={[0.1, 0.1, 1.8, 12]} />
      <Cylinder position={[0, 1, 0]} rotation={[0, 0, Math.PI / 2]} args={[0.125, 0.125, 1.2, 12]} color="#2a2a2a" />

      <Sphere position={[-1, 1, 0]} args={[0.15, 32, 32]} />

      <Cylinder position={[-1, 0.4, 0]} args={[0.1, 0.1, 1, 12]} />
      <Cylinder position={[-1, 0.2, 0]} args={[0.15, 0.15, 0.2, 12]} />

      <Cylinder position={[-1, 0, 0]} rotation={[Math.PI / 2, 0, 0]} args={[0.15, 0.15, 1, 12]} />
      <Cylinder position={[-1, 0, 0.5]} rotation={[Math.PI / 2, 0, 0]} args={[0.2, 0.2, 0.25, 12]} color="#2a2a2a" />
      <Cylinder position={[-1, 0, -0.5]} rotation={[Math.PI / 2, 0, 0]} args={[0.2, 0.2, 0.25, 12]} color="#2a2a2a" />

      <Sphere position={[1, 1, 0]} args={[0.15, 32, 32]} />

      <Cylinder position={[1, 0.4, 0]} args={[0.1, 0.1, 1, 12]} />
      <Cylinder position={[1, 0.2, 0]} args={[0.15, 0.15, 0.2, 12]} />

      <Cylinder position={[1, 0, 0]} rotation={[Math.PI / 2, 0, 0]} args={[0.15, 0.15, 1, 12]} />
      <Cylinder position={[1, 0, 0.5]} rotation={[Math.PI / 2, 0, 0]} args={[0.2, 0.2, 0.25, 12]} color="#2a2a2a" />
      <Cylinder position={[1, 0, -0.5]} rotation={[Math.PI / 2, 0, 0]} args={[0.2, 0.2, 0.25, 12]} color="#2a2a2a" />
    </group>
  );
};
